import { ReactNode } from "react";
import { SkipLinks } from "@/components/ui/SkipLinks";
import { DashboardSidebarLayout } from "@/components/layout/DashboardSidebarLayout";
import { AdminSidebar } from "@/components/layout/AdminSidebar";
import { useAuthReady } from "@/hooks/useAuthReady";
import { PageLoader } from "@/components/ui/PageLoader";

interface AdminLayoutProps {
  children: ReactNode;
}

export function NewAdminLayout({ children }: AdminLayoutProps) {
  const { isReady } = useAuthReady();

  if (!isReady) {
    return <PageLoader />;
  }

  return (
    <div className="min-h-screen bg-background">
      <SkipLinks />
      <DashboardSidebarLayout 
        sidebar={<AdminSidebar />}
        headerContext="admin"
      >
        {children}
      </DashboardSidebarLayout>
    </div>
  );
}
